/* eslint-disable prefer-object-spread,object-shorthand,no-nested-ternary */
import { toast } from 'react-toastify';
import React from 'react';
import axios, { CancelToken } from 'axios';

export const WEB_BASE_URL = 'https://onceinmemory.360diamondoncrown.com';
export const SERVICE_URL = 'https://onceinmemory-api.360diamondoncrown.com/api/';
// export const WEB_BASE_URL = 'http://localhost:3006';
// export const SERVICE_URL = 'http://localhost:3001/api/';

const requester = axios.create({
    baseURL: SERVICE_URL
});

export const showCommonError = (error) => {
    if (error.response && error.response.data) {
        let msg = "";

        switch (error.response.status) {
            // case 401:
            //     msg = 'รหัสผ่าน/การเข้าสู่ระบบผิดพลาด';
            //     break;
            case 403:
                msg = 'ขออภัย คุณไม่ได้รับสิทธิการเข้าถึงข้อมูลนี้';
                break;
            case 404:
                msg = 'ไม่พบข้อมูล';
                break;
            case 500:
                msg = 'เกิดข้อผิดพลาดเซิฟเวอร์ กรุณาติดต่อเจ้าหน้าที่';
                break;
            default:
                if (error.response.data.error) {
                    msg = error.response.data.error.message;
                } else {
                    msg = error.response.data.message;
                }
                break;
        }

        const msgHtml = () => <div
            dangerouslySetInnerHTML={{ __html: msg.replaceAll('\r\n', '<br/>') }}
        />
        toast.warn(msgHtml);
    }
};

/* ── token ของผู้ใช้ทั่วไป ────────────────────────────────────────────────
 * เดิมเบราว์เซอร์ปั้น token เองด้วย getToken() ซึ่งเท่ากับไม่มีการตรวจอะไรเลย
 * ตอนนี้ขอจาก POST /api/public/session ให้เซิร์ฟเวอร์เป็นคนออกให้แทน
 *
 * ทำผ่าน axios interceptor เพื่อไม่ต้องแก้จุดที่เรียก api.request ทั้ง 118 จุด
 * (การขอ token เป็น async แต่ getHeader เดิมเป็น sync)
 *
 * เก็บใน localStorage ไม่ใช่ sessionStorage เพราะ sessionStorage แยกกันคนละแท็บ
 * -- เปิด 5 แท็บจะขอ token 5 ใบทั้งที่ใช้ร่วมกันได้ เปลืองโควตาฝั่งเซิร์ฟเวอร์โดยไม่จำเป็น
 */
const PUBLIC_TOKEN_KEY = 'public_token';

/** instance แยกไว้ขอ token -- ห้ามมี interceptor ไม่งั้นจะวนขอ token ไม่รู้จบ */
const sessionRequester = axios.create({ baseURL: SERVICE_URL });

let pendingTokenRequest = null;

const readCachedToken = () => {
    try {
        const raw = localStorage.getItem(PUBLIC_TOKEN_KEY);
        if (!raw) return null;

        const { token, expiresAt } = JSON.parse(raw);
        // เผื่อไว้ 1 นาที กัน token หมดอายุพอดีระหว่างที่ request กำลังเดินทาง
        return expiresAt - 60000 > Date.now() ? token : null;
    } catch (e) {
        return null;
    }
}

const fetchPublicToken = () => {
    // หลาย request ที่ยิงพร้อมกันตอนเปิดหน้าให้รอ promise เดียวกัน ไม่ใช่ต่างคนต่างขอ
    if (pendingTokenRequest) return pendingTokenRequest;

    pendingTokenRequest = sessionRequester.post('public/session')
        .then(({ data }) => {
            try {
                localStorage.setItem(PUBLIC_TOKEN_KEY, JSON.stringify({
                    token: data.token,
                    expiresAt: Date.now() + (data.expiresIn * 1000)
                }));
            } catch (e) { /* โหมดไม่ระบุตัวตนเขียนไม่ได้ -- ใช้ในหน่วยความจำต่อไป */ }

            return data.token;
        })
        .finally(() => { pendingTokenRequest = null; });

    return pendingTokenRequest;
}

const ensurePublicToken = () => {
    const cached = readCachedToken();
    return cached ? Promise.resolve(cached) : fetchPublicToken();
}

/**
 * token ที่ใช้อยู่ตอนนี้ (ยังไม่มีจะได้ null)
 * ของเดิมฟังก์ชันนี้ปั้น token ปลอมขึ้นมาเอง ตอนนี้คืนตัวที่เซิร์ฟเวอร์ออกให้แทน
 */
const getToken = () => readCachedToken();

requester.interceptors.request.use(async (config) => {
    // ถ้ามีการส่ง token มาเองแล้ว (เช่น JWT ของพนักงาน) ไม่ต้องไปยุ่ง
    if (config.headers && config.headers['x-access-token']) return config;

    try {
        const token = await ensurePublicToken();
        if (token) config.headers['x-access-token'] = token;
    } catch (e) {
        // ขอ token ไม่ได้ก็ปล่อยให้ยิงไปแล้วไปโดน 403 ที่ฝั่ง API
        // จะได้เห็น error จริงแทนที่จะเงียบหายไปเฉย ๆ
    }

    return config;
});

requester.interceptors.response.use(undefined, async (error) => {
    const { response, config } = error;

    // token หมดอายุกลางคัน (เช่นเปิดหน้าค้างไว้นานเกิน 2 ชม. แล้วกดจอง)
    // ขอใหม่แล้วลองซ้ำ 1 ครั้ง เพื่อไม่ให้ลูกค้าเจอ error ทั้งที่แค่ต้องต่ออายุ
    if (response && response.status === 401 && config && !config.__retriedWithNewToken) {
        config.__retriedWithNewToken = true;

        try { localStorage.removeItem(PUBLIC_TOKEN_KEY); } catch (e) { /* ไม่เป็นไร */ }

        try {
            config.headers['x-access-token'] = await fetchPublicToken();
            return requester(config);
        } catch (e) { /* ขอใหม่ไม่สำเร็จ -- ปล่อย error เดิมออกไป */ }
    }

    return Promise.reject(error);
});

const getHeader = (token = null) => {
    if (!token) {
        return {}; // interceptor จะเติม token ของผู้ใช้ทั่วไปให้เอง
    }

    return { 'x-access-token': token };
}

const api = {
    request: (url, callback = () => { }, params = {}, method = 'GET', options = {}) => {
        options = { ...{ showError: method !== 'GET', showSuccess: false }, ...options }

        const cancelSource = CancelToken.source();
        const cancelToken = cancelSource.token;
        const { showError, baseURL, forceCallbackError } = options;

        requester(Object.assign({
            method,
            url,
            baseURL,
            headers: getHeader(options.token),
            cancelToken
        }, method === 'GET' ? { params: params } : { data: params })).then((response) => {
            callback(response.data, true);
            if (options.showSuccess) {
                toast.success(response.data.message ? response.data.message : (method === 'DELETE' ? 'Data removed !' : 'Data saved !'))
            }
        }).catch((error) => {
            if (forceCallbackError) {
                callback(error, false)
                return
            }

            if (!error.response) {
                return;
            }

            // if (error.response.status === 401 && error.response.data?.message === "Unauthorized!") {
            //     window.location.replace(`${WEB_BASE_URL}${DEFAULT_PATHS.LOGIN}`);
            //     callback({ items: [] }, false);
            //     return;
            // }

            if (showError) {
                showCommonError(error);
            }

            callback(null, false)
        });

        return cancelSource;
    },
    showCommonError: showCommonError,
    getToken: getToken
};

export default api;
